import {
  INITIATE_PAYOUT_START,
  MASSPAY_WITHDRAW_CLEAR,
  MASSPAY_WITHDRAW_FAILED,
  MASSPAY_WITHDRAW_SUCCESS,
} from "./ActionConstant";
import { INITIATE_PAYOUT_SUCCESS } from "./ActionConstant";
import { INITIATE_PAYOUT_FAILURE } from "./ActionConstant";
import { UPDATE_PAYOUT_ATTRIBUTE_VALUE ,UPDATE_PAYOUT_DUPLICATE_ATTRIBUTE_VALUE} from "./ActionConstant";
import {
  FETCH_PAYOUT_ATTRIBUTES_START,
  FETCH_PAYOUT_ATTRIBUTES_FAILURE,
  FETCH_PAYOUT_ATTRIBUTES_SUCCESS,
  UPDATE_PAYOUT,
  FETCH_PAYOUT_SERVICES_START,
  FETCH_PAYOUT_SERVICES_SUCCESS,
  FETCH_PAYOUT_SERVICES_FAILURE,
  FETCH_PAYOUT_DRAFT_SUCCESS,
  FETCH_PAYOUT_DRAFT_FAILURE,
  FETCH_PAYOUT_DRAFT_START,
  CONFIRM_PAYOUT_DRAFT_SUCCESS,
  CONFIRM_PAYOUT_DRAFT_FAILURE,
  CONFIRM_PAYOUT_DRAFT_START,
  MASSPAY_WITHDRAW_AMOUNT_IS_LESS,
  UPDATE_PAYOUT_MAX_AMOUNT,
  INITIATE_PAYOUT_TABLE,
  REFRESH_UNIQUEID,
  WITHDRAWAL_CONFIRM_DOWNLOAD_START,
  WITHDRAWAL_CONFIRM_DOWNLOAD_END
} from "./ActionConstant";

export function initiatePayoutStart(data) {
  return {
    type: INITIATE_PAYOUT_START,
    data,
  };
}
export function initiateTablePayoutStart(data) {
  return {
    type: INITIATE_PAYOUT_TABLE,
    data
  };
}
export function resetUniqueId() {
  return {
    type: REFRESH_UNIQUEID,
    
  };
}

export function initiatePayoutSuccess(data) {
  return {
    type: INITIATE_PAYOUT_SUCCESS,
    data,
  };
}

export function initiatePayoutFailure(error) {
  return {
    type: INITIATE_PAYOUT_FAILURE,
    error,
  };
}

export function fetchPayoutServicesStart(data) {
  return {
    type: FETCH_PAYOUT_SERVICES_START,
    data,
  };
}

export function fetchPayoutServicesSuccess(data) {
  return {
    type: FETCH_PAYOUT_SERVICES_SUCCESS,
    data,
  };
}

export function fetchPayoutServicesFailure(error) {
  return {
    type: FETCH_PAYOUT_SERVICES_FAILURE,
    error,
  };
}

export function updatePayoutInfo(data) {
  return {
    type: UPDATE_PAYOUT,
    data,
  };
}
export function updatePayoutInfoWithMaxAmount() {
  return {
    type: UPDATE_PAYOUT_MAX_AMOUNT,
  };
}

export function updateAttributeValue(data) {
  return {
    type: UPDATE_PAYOUT_ATTRIBUTE_VALUE,
    data,
  };
}

export function updateDuplicateAttributes(data) {
  return {
    type : UPDATE_PAYOUT_DUPLICATE_ATTRIBUTE_VALUE,
    data,
  }
}

export function fetchPayoutAttributesStart(data) {
  return {
    type: FETCH_PAYOUT_ATTRIBUTES_START,
    data,
  };
}

export function fetchPayoutAttributesSuccess(data) {
  return {
    type: FETCH_PAYOUT_ATTRIBUTES_SUCCESS,
    data,
  };
}

export function fetchPayoutAttributesFailure(error) {
  return {
    type: FETCH_PAYOUT_ATTRIBUTES_FAILURE,
    error,
  };
}

export function fetchPayoutDraftStart(data) {
  return {
    type: FETCH_PAYOUT_DRAFT_START,
    data,
  };
}

export function fetchPayoutDraftSuccess(data) {
  return {
    type: FETCH_PAYOUT_DRAFT_SUCCESS,
    data,
  };
}

export function fetchPayoutDraftFailure(error) {
  return {
    type: FETCH_PAYOUT_DRAFT_FAILURE,
    error,
  };
}

export function confirmPayoutDraftStart(data) {
  return {
    type: CONFIRM_PAYOUT_DRAFT_START,
    data,
  };
}

export function confirmPayoutDraftSuccess(data) {
  return {
    type: CONFIRM_PAYOUT_DRAFT_SUCCESS,
    data,
  };
}

export function confirmPayoutDraftFailure(error) {
  return {
    type: CONFIRM_PAYOUT_DRAFT_FAILURE,
    error,
  };
}

export function masspayWithdrawSuccess(data) {
  return {
    type: MASSPAY_WITHDRAW_SUCCESS,
    data,
  };
}

export function masspayWithdrawFailed() {
  return {
    type: MASSPAY_WITHDRAW_FAILED,
  };
}

export function masspayWithdrawClear() {
  return {
    type: MASSPAY_WITHDRAW_CLEAR,
  };
}

export function masspayWithdrawalAmountIsLess() {
  return {
    type: MASSPAY_WITHDRAW_AMOUNT_IS_LESS,
  };
}
export function fetchWithdrawalInvoiceStart(data) {
  return {
    type: WITHDRAWAL_CONFIRM_DOWNLOAD_START,
    data,
  };
}

export function fetchWithdrawalInvoiceEnd(data) {
  return {
    type: WITHDRAWAL_CONFIRM_DOWNLOAD_END,
  };
}
